var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutSecBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1920 712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#background_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "background_svg__b",
    width: 1921,
    height: 807,
    x: -1,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#040406",
    d: "M-.004 0h1920v807h-1920z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#background_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#040406",
    d: "M0 0h1920v712H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__c)",
    d: "M0 0h1920v712H0z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__d)",
    fillOpacity: 0.04,
    d: "M698.668 100.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__e)",
    fillOpacity: 0.6,
    d: "M698.668 100.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__f)",
    fillOpacity: 0.04,
    d: "M740.816 100.101v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__g)",
    fillOpacity: 0.6,
    d: "M740.816 100.101v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__h)",
    fillOpacity: 0.04,
    d: "M551.316 136.175v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__i)",
    fillOpacity: 0.6,
    d: "M551.316 136.175v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__j)",
    fillOpacity: 0.04,
    d: "M635.605 136.175v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__k)",
    fillOpacity: 0.6,
    d: "M635.605 136.175v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__l)",
    fillOpacity: 0.04,
    d: "M677.777 136.175v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__m)",
    fillOpacity: 0.6,
    d: "M677.777 136.175v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__n)",
    fillOpacity: 0.04,
    d: "M846.387 136.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__o)",
    fillOpacity: 0.6,
    d: "M846.387 136.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__p)",
    fillOpacity: 0.04,
    d: "M487.887 172.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__q)",
    fillOpacity: 0.6,
    d: "M487.887 172.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__r)",
    fillOpacity: 0.04,
    d: "M698.668 172.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__s)",
    fillOpacity: 0.6,
    d: "M698.668 172.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__t)",
    fillOpacity: 0.04,
    d: "M782.957 172.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__u)",
    fillOpacity: 0.6,
    d: "M782.957 172.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__v)",
    fillOpacity: 0.04,
    d: "M635.605 207.972v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__w)",
    fillOpacity: 0.6,
    d: "M635.605 207.972v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__x)",
    fillOpacity: 0.04,
    d: "M804.246 207.972v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__y)",
    fillOpacity: 0.6,
    d: "M804.246 207.972v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__z)",
    fillOpacity: 0.04,
    d: "M846.387 207.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__A)",
    fillOpacity: 0.6,
    d: "M846.387 207.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__B)",
    fillOpacity: 0.04,
    d: "M614.777 28.576v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__C)",
    fillOpacity: 0.6,
    d: "M614.777 28.576v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__D)",
    fillOpacity: 0.04,
    d: "M741.246 28.576v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__E)",
    fillOpacity: 0.6,
    d: "M741.246 28.576v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__F)",
    fillOpacity: 0.04,
    d: "M614.418 244.247v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__G)",
    fillOpacity: 0.6,
    d: "M614.418 244.247v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__H)",
    fillOpacity: 0.04,
    d: "M740.871 244.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__I)",
    fillOpacity: 0.6,
    d: "M740.871 244.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__J)",
    fillOpacity: 0.1,
    d: "M551.316 64.464v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__K)",
    fillOpacity: 0.04,
    d: "M551.316 64.464v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__L)",
    fillOpacity: 0.1,
    d: "M593.457 64.464v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__M)",
    fillOpacity: 0.04,
    d: "M593.457 64.464v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__N)",
    fillOpacity: 0.1,
    d: "M635.605 64.464v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__O)",
    fillOpacity: 0.04,
    d: "M635.605 64.464v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__P)",
    fillOpacity: 0.1,
    d: "M530.027 100.101v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__Q)",
    fillOpacity: 0.04,
    d: "M530.027 100.101v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__R)",
    fillOpacity: 0.1,
    d: "M656.496 100.101v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__S)",
    fillOpacity: 0.04,
    d: "M656.496 100.101v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__T)",
    fillOpacity: 0.1,
    d: "M782.957 100.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__U)",
    fillOpacity: 0.04,
    d: "M782.957 100.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__V)",
    fillOpacity: 0.1,
    d: "M825.137 100.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__W)",
    fillOpacity: 0.04,
    d: "M825.137 100.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__X)",
    fillOpacity: 0.1,
    d: "M719.926 136.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__Y)",
    fillOpacity: 0.04,
    d: "M719.926 136.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__Z)",
    fillOpacity: 0.1,
    d: "M762.066 136.175v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aa)",
    fillOpacity: 0.04,
    d: "M762.066 136.175v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ab)",
    fillOpacity: 0.1,
    d: "M804.246 136.175v22.6l19.775 11.301 19.776-11.301v-22.6l-19.776-11.3z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ac)",
    fillOpacity: 0.04,
    d: "M804.246 136.175v22.6l19.775 11.301 19.776-11.301v-22.6l-19.776-11.3z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ad)",
    fillOpacity: 0.1,
    d: "M593.824-7.7v22.6l19.775 11.3 19.776-11.3V-7.7L613.599-19z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ae)",
    fillOpacity: 0.04,
    d: "M593.824-7.7v22.6l19.775 11.3 19.776-11.3V-7.7L613.599-19z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__af)",
    fillOpacity: 0.1,
    d: "M635.965-7.7v22.6l19.775 11.3 19.775-11.3V-7.7L655.74-19z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ag)",
    fillOpacity: 0.04,
    d: "M635.965-7.7v22.6l19.775 11.3 19.775-11.3V-7.7L655.74-19z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ah)",
    fillOpacity: 0.1,
    d: "M678.145-7.7v22.6l19.775 11.3 19.775-11.3V-7.7L697.92-19z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ai)",
    fillOpacity: 0.04,
    d: "M678.145-7.7v22.6l19.775 11.3 19.775-11.3V-7.7L697.92-19z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aj)",
    fillOpacity: 0.1,
    d: "M551.316 207.972v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ak)",
    fillOpacity: 0.04,
    d: "M551.316 207.972v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__al)",
    fillOpacity: 0.1,
    d: "M593.457 207.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__am)",
    fillOpacity: 0.04,
    d: "M593.457 207.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__an)",
    fillOpacity: 0.1,
    d: "M677.777 207.972v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ao)",
    fillOpacity: 0.04,
    d: "M677.777 207.972v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ap)",
    fillOpacity: 0.1,
    d: "M530.48 28.576v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aq)",
    fillOpacity: 0.04,
    d: "M530.48 28.576v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ar)",
    fillOpacity: 0.1,
    d: "M572.629 28.576v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__as)",
    fillOpacity: 0.04,
    d: "M572.629 28.576v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__at)",
    fillOpacity: 0.1,
    d: "M699.098 28.576v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__au)",
    fillOpacity: 0.04,
    d: "M699.098 28.576v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__av)",
    fillOpacity: 0.1,
    d: "M698.73 244.247v22.601l19.776 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aw)",
    fillOpacity: 0.04,
    d: "M698.73 244.247v22.601l19.776 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ax)",
    fillOpacity: 0.1,
    d: "M783.027 244.247v22.601l19.776 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ay)",
    fillOpacity: 0.04,
    d: "M783.027 244.247v22.601l19.776 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__az)",
    fillOpacity: 0.1,
    d: "M825.191 244.247v22.601l19.776 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aA)",
    fillOpacity: 0.04,
    d: "M825.191 244.247v22.601l19.776 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aB)",
    fillOpacity: 0.3,
    d: "M466.996 64.464v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aC)",
    fillOpacity: 0.16,
    d: "M466.996 64.464v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aD)",
    fillOpacity: 0.3,
    d: "M509.137 64.464v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aE)",
    fillOpacity: 0.16,
    d: "M509.137 64.464v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aF)",
    fillOpacity: 0.3,
    d: "M677.777 64.464v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aG)",
    fillOpacity: 0.16,
    d: "M677.777 64.464v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aH)",
    fillOpacity: 0.3,
    d: "M719.926 64.464v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aI)",
    fillOpacity: 0.16,
    d: "M719.926 64.464v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aJ)",
    fillOpacity: 0.3,
    d: "M762.066 64.464v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aK)",
    fillOpacity: 0.16,
    d: "M762.066 64.464v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aL)",
    fillOpacity: 0.3,
    d: "M804.246 64.464v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aM)",
    fillOpacity: 0.16,
    d: "M804.246 64.464v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aN)",
    fillOpacity: 0.3,
    d: "M846.387 64.464v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aO)",
    fillOpacity: 0.16,
    d: "M846.387 64.464v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aP)",
    fillOpacity: 0.3,
    d: "M487.887 100.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aQ)",
    fillOpacity: 0.16,
    d: "M487.887 100.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aR)",
    fillOpacity: 0.3,
    d: "M572.199 100.101v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aS)",
    fillOpacity: 0.16,
    d: "M572.199 100.101v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aT)",
    fillOpacity: 0.3,
    d: "M614.348 100.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aU)",
    fillOpacity: 0.16,
    d: "M614.348 100.101v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aV)",
    fillOpacity: 0.3,
    d: "M466.996 136.175v22.6l19.775 11.301 19.776-11.301v-22.6l-19.776-11.3z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aW)",
    fillOpacity: 0.16,
    d: "M466.996 136.175v22.6l19.775 11.301 19.776-11.301v-22.6l-19.776-11.3z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aX)",
    fillOpacity: 0.3,
    d: "M509.137 136.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aY)",
    fillOpacity: 0.16,
    d: "M509.137 136.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__aZ)",
    fillOpacity: 0.3,
    d: "M530.027 172.197v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ba)",
    fillOpacity: 0.16,
    d: "M530.027 172.197v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bb)",
    fillOpacity: 0.3,
    d: "M572.199 172.197v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bc)",
    fillOpacity: 0.16,
    d: "M572.199 172.197v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bd)",
    fillOpacity: 0.3,
    d: "M614.348 172.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__be)",
    fillOpacity: 0.16,
    d: "M614.348 172.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bf)",
    fillOpacity: 0.3,
    d: "M656.496 172.197v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bg)",
    fillOpacity: 0.16,
    d: "M656.496 172.197v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bh)",
    fillOpacity: 0.3,
    d: "M740.816 172.197v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bi)",
    fillOpacity: 0.16,
    d: "M740.816 172.197v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bj)",
    fillOpacity: 0.3,
    d: "M825.137 172.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bk)",
    fillOpacity: 0.16,
    d: "M825.137 172.197v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bl)",
    fillOpacity: 0.3,
    d: "M509.512-7.7v22.6l19.775 11.3 19.775-11.3V-7.7L529.287-19z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bm)",
    fillOpacity: 0.16,
    d: "M509.512-7.7v22.6l19.775 11.3 19.775-11.3V-7.7L529.287-19z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bn)",
    fillOpacity: 0.3,
    d: "M551.676-7.7v22.6l19.775 11.3 19.775-11.3V-7.7L571.451-19z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bo)",
    fillOpacity: 0.16,
    d: "M551.676-7.7v22.6l19.775 11.3 19.775-11.3V-7.7L571.451-19z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bp)",
    fillOpacity: 0.3,
    d: "M720.285-7.7v22.6l19.775 11.3 19.776-11.3V-7.7L740.06-19z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bq)",
    fillOpacity: 0.16,
    d: "M720.285-7.7v22.6l19.775 11.3 19.776-11.3V-7.7L740.06-19z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__br)",
    fillOpacity: 0.3,
    d: "M762.434-7.7v22.6l19.775 11.3 19.775-11.3V-7.7L782.209-19z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bs)",
    fillOpacity: 0.16,
    d: "M762.434-7.7v22.6l19.775 11.3 19.775-11.3V-7.7L782.209-19z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bt)",
    fillOpacity: 0.3,
    d: "M804.605-7.7v22.6l19.776 11.3 19.775-11.3V-7.7L824.381-19z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bu)",
    fillOpacity: 0.16,
    d: "M804.605-7.7v22.6l19.776 11.3 19.775-11.3V-7.7L824.381-19z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bv)",
    fillOpacity: 0.3,
    d: "M466.996 207.972v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bw)",
    fillOpacity: 0.16,
    d: "M466.996 207.972v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bx)",
    fillOpacity: 0.3,
    d: "M509.137 207.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__by)",
    fillOpacity: 0.16,
    d: "M509.137 207.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bz)",
    fillOpacity: 0.3,
    d: "M719.926 207.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bA)",
    fillOpacity: 0.16,
    d: "M719.926 207.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bB)",
    fillOpacity: 0.3,
    d: "M762.066 207.972v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bC)",
    fillOpacity: 0.16,
    d: "M762.066 207.972v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bD)",
    fillOpacity: 0.3,
    d: "M488.316 28.576v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bE)",
    fillOpacity: 0.16,
    d: "M488.316 28.576v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bF)",
    fillOpacity: 0.3,
    d: "M656.949 28.576v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bG)",
    fillOpacity: 0.16,
    d: "M656.949 28.576v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bH)",
    fillOpacity: 0.3,
    d: "M783.387 28.576v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bI)",
    fillOpacity: 0.16,
    d: "M783.387 28.576v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bJ)",
    fillOpacity: 0.3,
    d: "M825.566 28.576v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bK)",
    fillOpacity: 0.16,
    d: "M825.566 28.576v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bL)",
    fillOpacity: 0.3,
    d: "M487.949 244.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bM)",
    fillOpacity: 0.16,
    d: "M487.949 244.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bN)",
    fillOpacity: 0.3,
    d: "M530.113 244.247v22.601l19.776 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bO)",
    fillOpacity: 0.16,
    d: "M530.113 244.247v22.601l19.776 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bP)",
    fillOpacity: 0.3,
    d: "M572.262 244.247v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bQ)",
    fillOpacity: 0.16,
    d: "M572.262 244.247v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bR)",
    fillOpacity: 0.3,
    d: "M656.574 244.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bS)",
    fillOpacity: 0.16,
    d: "M656.574 244.247v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bT)",
    fillOpacity: 0.3,
    d: "M593.457 136.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__bU)",
    fillOpacity: 0.16,
    d: "M593.457 136.175v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#111B22",
    fillOpacity: 0.9,
    d: "M551.199 136.21v22.601l19.775 11.3 19.776-11.3V136.21l-19.776-11.3z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__bV)",
    strokeLinecap: "round",
    strokeOpacity: 0.25,
    d: "m570.974 169.535-19.275-11.015V136.5l19.275-11.014L590.25 136.5v22.02z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__bW)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m570.974 169.535-19.275-11.015V136.5l19.275-11.014L590.25 136.5v22.02z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#090F14",
    d: "M509.047 136.269v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__bX)",
    strokeLinecap: "round",
    strokeOpacity: 0.25,
    d: "m528.822 169.593-19.275-11.014v-22.02l19.275-11.014 19.275 11.014v22.02z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__bY)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m528.822 169.593-19.275-11.014v-22.02l19.275-11.014 19.275 11.014v22.02z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__bZ)",
    strokeOpacity: 0.68,
    d: "M549.996 136v22.5m0 0 21.5 12.5m-21.5-12.5-20.5 12.5m42 0v23.5l-21.5 11.5m21.5-35 19-11"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C1319",
    d: "M529.914 171.865v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.301z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__ca)",
    strokeLinecap: "round",
    strokeOpacity: 0.07,
    d: "m549.689 205.189-19.275-11.014v-22.02l19.275-11.015 19.276 11.015v22.02z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__cb)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m549.689 205.189-19.275-11.014v-22.02l19.275-11.015 19.276 11.015v22.02z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A0F14",
    d: "M572.195 171.984v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__cc)",
    strokeLinecap: "round",
    strokeOpacity: 0.25,
    d: "m591.971 205.308-19.276-11.014v-22.02l19.276-11.015 19.275 11.015v22.02z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__cd)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m591.971 205.308-19.276-11.014v-22.02l19.276-11.015 19.275 11.015v22.02z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ce)",
    fillOpacity: 0.6,
    d: "M1461.67 458.101v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cf)",
    fillOpacity: 0.6,
    d: "M1503.82 458.101v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cg)",
    fillOpacity: 0.6,
    d: "M1314.32 494.175v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ch)",
    fillOpacity: 0.6,
    d: "M1398.61 494.175v22.6l19.77 11.301 19.78-11.301v-22.6l-19.78-11.3z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ci)",
    fillOpacity: 0.6,
    d: "M1440.78 494.175v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cj)",
    fillOpacity: 0.6,
    d: "M1609.39 494.175v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ck)",
    fillOpacity: 0.6,
    d: "M1250.89 530.197v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cl)",
    fillOpacity: 0.6,
    d: "M1461.67 530.197v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cm)",
    fillOpacity: 0.6,
    d: "M1545.96 530.197v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cn)",
    fillOpacity: 0.6,
    d: "M1398.61 565.972v22.6l19.77 11.3 19.78-11.3v-22.6l-19.78-11.3z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__co)",
    fillOpacity: 0.6,
    d: "M1567.25 565.972v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cp)",
    fillOpacity: 0.6,
    d: "M1609.39 565.972v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cq)",
    fillOpacity: 0.6,
    d: "M1377.78 386.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cr)",
    fillOpacity: 0.6,
    d: "M1504.25 386.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cs)",
    fillOpacity: 0.6,
    d: "M1377.42 602.247v22.601l19.78 11.3 19.77-11.3v-22.601l-19.77-11.3z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ct)",
    fillOpacity: 0.6,
    d: "M1503.88 602.247v22.601l19.77 11.3 19.78-11.3v-22.601l-19.78-11.3z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cu)",
    fillOpacity: 0.2,
    d: "M1314.32 422.464v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cv)",
    fillOpacity: 0.2,
    d: "M1356.46 422.464v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cw)",
    fillOpacity: 0.2,
    d: "M1398.61 422.464v22.6l19.77 11.301 19.78-11.301v-22.6l-19.78-11.3z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cx)",
    fillOpacity: 0.2,
    d: "M1293.03 458.101v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cy)",
    fillOpacity: 0.2,
    d: "M1419.5 458.101v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cz)",
    fillOpacity: 0.2,
    d: "M1545.96 458.101v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cA)",
    fillOpacity: 0.2,
    d: "M1588.14 458.101v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cB)",
    fillOpacity: 0.2,
    d: "M1482.93 494.175v22.6l19.77 11.301 19.78-11.301v-22.6l-19.78-11.3z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cC)",
    fillOpacity: 0.2,
    d: "M1525.07 494.175v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cD)",
    fillOpacity: 0.2,
    d: "M1567.25 494.175v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cE)",
    fillOpacity: 0.2,
    d: "M1356.83 350.3v22.6l19.77 11.301 19.78-11.301v-22.6L1376.6 339z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cF)",
    fillOpacity: 0.2,
    d: "M1398.97 350.3v22.6l19.77 11.301 19.78-11.301v-22.6l-19.78-11.3z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cG)",
    fillOpacity: 0.2,
    d: "M1441.15 350.3v22.6l19.77 11.301 19.78-11.301v-22.6l-19.78-11.3z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cH)",
    fillOpacity: 0.2,
    d: "M1314.32 565.972v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cI)",
    fillOpacity: 0.2,
    d: "M1356.46 565.972v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cJ)",
    fillOpacity: 0.2,
    d: "M1440.78 565.972v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cK)",
    fillOpacity: 0.2,
    d: "M1293.48 386.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cL)",
    fillOpacity: 0.2,
    d: "M1335.63 386.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cM)",
    fillOpacity: 0.2,
    d: "M1462.1 386.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cN)",
    fillOpacity: 0.2,
    d: "M1461.73 602.247v22.601l19.78 11.3 19.77-11.3v-22.601l-19.77-11.3z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cO)",
    fillOpacity: 0.2,
    d: "M1546.03 602.247v22.601l19.78 11.3 19.77-11.3v-22.601l-19.77-11.3z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cP)",
    fillOpacity: 0.2,
    d: "M1588.2 602.247v22.601l19.77 11.3 19.78-11.3v-22.601l-19.78-11.3z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cQ)",
    fillOpacity: 0.08,
    d: "M1441.77 280.095v22.191l19.28 11.096 19.29-11.096v-22.191L1461.05 269z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cR)",
    fillOpacity: 0.08,
    d: "M1482.86 280.095v22.191l19.29 11.096 19.28-11.096v-22.191L1502.15 269z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cS)",
    fillOpacity: 0.08,
    d: "M1524 280.095v22.191l19.28 11.096 19.29-11.096v-22.191L1543.28 269z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cT)",
    fillOpacity: 0.08,
    d: "M1544.43 315.714v22.191L1563.71 349l19.29-11.095v-22.191l-19.29-11.096z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cU)",
    fillOpacity: 0.08,
    d: "m1625.29 315.452-19.22-11.095-19.25 11.153-.04 22.248 19.22 11.096 19.25-11.153z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cV)",
    fillOpacity: 0.08,
    d: "m1604.74 351.041-19.22-11.095-19.25 11.153-.03 22.248 19.21 11.096 19.26-11.153z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cW)",
    fillOpacity: 0.08,
    d: "m1584.17 386.663-19.22-11.095-19.25 11.153-.03 22.248 19.22 11.095 19.25-11.153z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cX)",
    fillOpacity: 0.08,
    d: "m1543.11 386.549-19.22-11.095-19.25 11.153-.03 22.248 19.21 11.096 19.26-11.153z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cY)",
    fillOpacity: 0.06,
    d: "M1230 422.464v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__cZ)",
    fillOpacity: 0.06,
    d: "M1272.14 422.464v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__da)",
    fillOpacity: 0.06,
    d: "M1440.78 422.464v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__db)",
    fillOpacity: 0.06,
    d: "M1482.93 422.464v22.6l19.77 11.301 19.78-11.301v-22.6l-19.78-11.3z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dc)",
    fillOpacity: 0.06,
    d: "M1525.07 422.464v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dd)",
    fillOpacity: 0.06,
    d: "M1567.25 422.464v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__de)",
    fillOpacity: 0.06,
    d: "M1609.39 422.464v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__df)",
    fillOpacity: 0.06,
    d: "M1250.89 458.101v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dg)",
    fillOpacity: 0.06,
    d: "M1335.2 458.101v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dh)",
    fillOpacity: 0.06,
    d: "M1377.35 458.101v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__di)",
    fillOpacity: 0.06,
    d: "M1230 494.175v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dj)",
    fillOpacity: 0.06,
    d: "M1272.14 494.175v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dk)",
    fillOpacity: 0.06,
    d: "M1293.03 530.197v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dl)",
    fillOpacity: 0.06,
    d: "M1335.2 530.197v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dm)",
    fillOpacity: 0.06,
    d: "M1377.35 530.197v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dn)",
    fillOpacity: 0.06,
    d: "M1419.5 530.197v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__do)",
    fillOpacity: 0.06,
    d: "M1503.82 530.197v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dp)",
    fillOpacity: 0.06,
    d: "M1588.14 530.197v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dq)",
    fillOpacity: 0.06,
    d: "M1272.52 350.3v22.6l19.77 11.301 19.78-11.301v-22.6l-19.78-11.3z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dr)",
    fillOpacity: 0.06,
    d: "M1314.68 350.3v22.6l19.77 11.301 19.78-11.301v-22.6l-19.78-11.3z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__ds)",
    fillOpacity: 0.06,
    d: "M1483.29 350.3v22.6l19.77 11.301 19.78-11.301v-22.6l-19.78-11.3z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dt)",
    fillOpacity: 0.06,
    d: "M1525.44 350.3v22.6l19.77 11.301 19.78-11.301v-22.6l-19.78-11.3z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__du)",
    fillOpacity: 0.06,
    d: "M1567.61 350.3v22.6l19.77 11.301 19.78-11.301v-22.6l-19.78-11.3z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dv)",
    fillOpacity: 0.06,
    d: "M1230 565.972v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dw)",
    fillOpacity: 0.06,
    d: "M1272.14 565.972v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dx)",
    fillOpacity: 0.06,
    d: "M1482.93 565.972v22.6l19.77 11.3 19.78-11.3v-22.6l-19.78-11.3z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dy)",
    fillOpacity: 0.06,
    d: "M1525.07 565.972v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.3z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dz)",
    fillOpacity: 0.06,
    d: "M1251.32 386.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dA)",
    fillOpacity: 0.06,
    d: "M1419.95 386.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dB)",
    fillOpacity: 0.06,
    d: "M1546.39 386.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dC)",
    fillOpacity: 0.06,
    d: "M1588.57 386.576v22.6l19.78 11.3 19.77-11.3v-22.6l-19.77-11.301z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dD)",
    fillOpacity: 0.06,
    d: "M1250.95 602.247v22.601l19.78 11.3 19.77-11.3v-22.601l-19.77-11.3z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dE)",
    fillOpacity: 0.06,
    d: "M1293.12 602.247v22.601l19.77 11.3 19.78-11.3v-22.601l-19.78-11.3z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dF)",
    fillOpacity: 0.06,
    d: "M1335.27 602.247v22.601l19.77 11.3 19.78-11.3v-22.601l-19.78-11.3z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dG)",
    fillOpacity: 0.06,
    d: "M1419.58 602.247v22.601l19.77 11.3 19.78-11.3v-22.601l-19.78-11.3z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#background_svg__dH)",
    fillOpacity: 0.06,
    d: "M1356.46 494.175v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A1116",
    d: "M1272 494.3v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dI)",
    strokeLinecap: "round",
    strokeOpacity: 0.36,
    d: "M1272 494.3v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dJ)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "M1272 494.3v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "#080E12",
    d: "M1293 458.3v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dK)",
    strokeLinecap: "round",
    strokeOpacity: 0.36,
    d: "M1293 458.3v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dL)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "M1293 458.3v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "#080E12",
    d: "M1504.2 315.017v22.6l19.77 11.3 19.78-11.3v-22.6l-19.78-11.3z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dM)",
    strokeLinecap: "round",
    strokeOpacity: 0.19,
    d: "m1523.97 348.341-19.27-11.014v-22.02l19.27-11.014 19.28 11.014v22.02z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dN)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m1523.97 348.341-19.27-11.014v-22.02l19.27-11.014 19.28 11.014v22.02z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "#080E12",
    d: "M1525.45 350.796v22.6l19.78 11.301 19.77-11.301v-22.6l-19.77-11.3z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dO)",
    strokeLinecap: "round",
    strokeOpacity: 0.12,
    d: "m1545.23 384.121-19.28-11.015v-22.02l19.28-11.014 19.27 11.014v22.02z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dP)",
    strokeLinecap: "round",
    strokeOpacity: 0.49,
    d: "m1545.23 384.121-19.28-11.015v-22.02l19.28-11.014 19.27 11.014v22.02z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A1218",
    d: "M1483.3 350.829v22.601l19.77 11.3 19.78-11.3v-22.601l-19.78-11.3z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dQ)",
    strokeLinecap: "round",
    strokeOpacity: 0.4,
    d: "m1503.07 384.154-19.27-11.014v-22.02l19.27-11.015 19.28 11.015v22.02z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#background_svg__dR)",
    strokeOpacity: 0.68,
    d: "m1542.01 339.336-17.93 11m0 0v23.5l21.5 12.216m-21.5-35.716-19-11"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(133.474 570.374 230.395)scale(1088.62 579.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F3242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1219",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 318.37 587.85)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 318.37 587.85)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 318.37 587.85)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 318.37 587.85)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 318.37 587.85)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 318.37 587.85)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 318.37 587.85)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__s",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 318.37 587.85)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__u",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 318.37 587.85)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__w",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 318.37 587.85)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 318.37 587.85)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__A",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 318.37 587.85)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__C",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 318.37 587.85)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__E",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 318.37 587.85)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__G",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 318.37 587.85)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__I",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(74.715 318.37 587.85)scale(83.4521 108.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13151A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13151A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__J",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 561.996 165.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0D10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__K",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 349.026 182.106)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__L",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 561.996 165.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0D10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__M",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 349.026 182.106)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__N",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 561.996 165.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0D10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__O",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 349.026 182.106)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__P",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 561.996 165.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0D10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__Q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 349.026 182.106)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__R",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 561.996 165.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0D10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__S",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 349.026 182.106)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__T",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 561.996 165.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0D10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__U",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 349.026 182.106)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__V",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 561.996 165.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0D10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__W",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 349.026 182.106)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__X",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 561.996 165.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0D10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__Y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 349.026 182.106)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__Z",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 561.996 165.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0D10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aa",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 349.026 182.106)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ab",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 561.996 165.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0D10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ac",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 349.026 182.106)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ad",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 561.996 165.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0D10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ae",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 349.026 182.106)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__af",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 561.996 165.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0D10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ag",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 349.026 182.106)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ah",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 561.996 165.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0D10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ai",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 349.026 182.106)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 561.996 165.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0D10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ak",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 349.026 182.106)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__al",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 561.996 165.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0D10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__am",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 349.026 182.106)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__an",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 561.996 165.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0D10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ao",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 349.026 182.106)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ap",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 561.996 165.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0D10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 349.026 182.106)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ar",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 561.996 165.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0D10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__as",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 349.026 182.106)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__at",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 561.996 165.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0D10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__au",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 349.026 182.106)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__av",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 561.996 165.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0D10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 349.026 182.106)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ax",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 561.996 165.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0D10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ay",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 349.026 182.106)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__az",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(146.00025 9.50001 -10.70104 164.45822 561.996 165.771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0D10",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(119.932 349.026 182.106)scale(95.1972 107.232)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__aZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ba",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bb",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bd",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__be",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bf",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bh",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bi",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bk",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bl",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bm",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bn",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bo",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bp",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__br",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bs",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bt",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bu",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bv",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bx",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__by",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bz",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(123.99983 -23.49995 24.55646 129.5746 561.996 170.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#16232F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16232F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.858 332.226 79.736)scale(76.1255 94.0592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2326",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-29.81519 31.0118 -34.73319 -33.39298 590.75 130.476)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(34.69356 -22.9974 25.75708 38.85676 556.056 166.715)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(126.762 252.631 193.874)scale(67.4435 75.5367)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__bY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(34.69356 -22.9974 25.75708 38.85676 513.904 166.773)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ca",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(126.762 254.145 216.901)scale(67.4435 75.5367)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cb",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(34.69356 -22.9974 25.75708 38.85676 534.771 202.369)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(126.762 275.255 227.556)scale(67.4435 75.5367)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cd",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(34.69356 -22.9974 25.75708 38.85676 577.052 202.488)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ce",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(44.67495 70.16156 -91.59067 58.3198 1363 518)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1118",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cf",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(44.67495 70.16156 -91.59067 58.3198 1363 518)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1118",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(44.67495 70.16156 -91.59067 58.3198 1363 518)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1118",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ch",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(44.67495 70.16156 -91.59067 58.3198 1363 518)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1118",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ci",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(44.67495 70.16156 -91.59067 58.3198 1363 518)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1118",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(44.67495 70.16156 -91.59067 58.3198 1363 518)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1118",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ck",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(44.67495 70.16156 -91.59067 58.3198 1363 518)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1118",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cl",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(44.67495 70.16156 -91.59067 58.3198 1363 518)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1118",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cm",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(44.67495 70.16156 -91.59067 58.3198 1363 518)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1118",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cn",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(44.67495 70.16156 -91.59067 58.3198 1363 518)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1118",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__co",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(44.67495 70.16156 -91.59067 58.3198 1363 518)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1118",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cp",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(44.67495 70.16156 -91.59067 58.3198 1363 518)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1118",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(44.67495 70.16156 -91.59067 58.3198 1363 518)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1118",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cr",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(44.67495 70.16156 -91.59067 58.3198 1363 518)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1118",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cs",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(44.67495 70.16156 -91.59067 58.3198 1363 518)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1118",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ct",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(44.67495 70.16156 -91.59067 58.3198 1363 518)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1118",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cu",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1323 508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cv",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1323 508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1323 508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cx",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1323 508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cy",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1323 508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cz",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1323 508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1323 508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1323 508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1323 508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1323 508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1323 508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1323 508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1323 508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1323 508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1323 508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1323 508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1323 508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1323 508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1323 508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1323 508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1323 508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(92.50035 42.00013 -29.99998 66.07143 1323 508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5269",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D5269",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-158.937 807.966 13.77)scale(79.2985 89.0152)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cR",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-158.937 807.966 13.77)scale(79.2985 89.0152)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-158.937 807.966 13.77)scale(79.2985 89.0152)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-158.937 807.966 13.77)scale(79.2985 89.0152)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-26.131 1627.822 -3051.87)scale(88.5508 99.4013)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cV",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-26.131 1627.822 -3051.87)scale(88.5508 99.4013)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-26.131 1627.822 -3051.87)scale(88.5508 99.4013)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-26.131 1627.822 -3051.87)scale(88.5508 99.4013)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343A4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__cZ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__da",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__db",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dd",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__de",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__df",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dh",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__di",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dk",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dl",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dm",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dn",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__do",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dp",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dr",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__ds",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dt",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__du",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dv",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dx",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dy",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dz",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dB",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dF",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(106.00026 -92.00018 66.9998 77.19545 1372 498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E475F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3B445C",
    stopOpacity: 0.378
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101222",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.49998 23.49998 -26.31997 35.27997 1272 490.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dJ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-35.50001 -9.00003 10.08004 -39.76004 1325.5 518)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(22.203 -519.27 3455.979)scale(52.9245 59.2754)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-117.553 813.788 -153.149)scale(38.9134 43.583)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(43.50002 -17.50004 19.60005 48.72004 1493 341.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dN",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-55.80845 30.21707 -33.84314 -62.5055 1560 306.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(57.5 -18.49998 20.72 64.40005 1516 376.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-68.55058 45.99638 -51.51597 -76.7767 1594 326.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "background_svg__dQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(57.5 -18.49998 20.72 64.40005 1473.85 376.533)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__d",
    x1: 571.996,
    x2: 649.496,
    y1: 198.271,
    y2: 326.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__f",
    x1: 571.996,
    x2: 649.496,
    y1: 198.271,
    y2: 326.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__h",
    x1: 571.996,
    x2: 649.496,
    y1: 198.271,
    y2: 326.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__j",
    x1: 571.996,
    x2: 649.496,
    y1: 198.271,
    y2: 326.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__l",
    x1: 571.996,
    x2: 649.496,
    y1: 198.271,
    y2: 326.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__n",
    x1: 571.996,
    x2: 649.496,
    y1: 198.271,
    y2: 326.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__p",
    x1: 571.996,
    x2: 649.496,
    y1: 198.271,
    y2: 326.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__r",
    x1: 571.996,
    x2: 649.496,
    y1: 198.271,
    y2: 326.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__t",
    x1: 571.996,
    x2: 649.496,
    y1: 198.271,
    y2: 326.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__v",
    x1: 571.996,
    x2: 649.496,
    y1: 198.271,
    y2: 326.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__x",
    x1: 571.996,
    x2: 649.496,
    y1: 198.271,
    y2: 326.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__z",
    x1: 571.996,
    x2: 649.496,
    y1: 198.271,
    y2: 326.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__B",
    x1: 571.996,
    x2: 649.496,
    y1: 198.271,
    y2: 326.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__D",
    x1: 571.996,
    x2: 649.496,
    y1: 198.271,
    y2: 326.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__F",
    x1: 571.996,
    x2: 649.496,
    y1: 198.271,
    y2: 326.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__H",
    x1: 571.996,
    x2: 649.496,
    y1: 198.271,
    y2: 326.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20262A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20262A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__bZ",
    x1: 575.496,
    x2: 546.49,
    y1: 152,
    y2: 205.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0C0C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background_svg__dR",
    x1: 1505,
    x2: 1537.34,
    y1: 343.5,
    y2: 351.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#0C0C0C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0C0C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "background_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1920v712H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutSecBg);
export default __webpack_public_path__ + "static/media/about-sec-bg.36621adc85d8ffb56c523212105fffe2.svg";
export { ForwardRef as ReactComponent };